import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';

const name = 'snackbar';

const slice = createSlice({
  name,
  initialState: {
    open: false,
    message: '',
  },
  reducers: {
    openSnackbar: (state, { payload }: PayloadAction<string>) => {
      state.message = payload;
      state.open = true;
    },
    closeSnackbar: (state) => {
      state.open = false;
    },
  },
});

/** General Action */
export const { openSnackbar, closeSnackbar } = slice.actions;

/** Reducer */
export const snackbar = slice.reducer;

export const selector = createSelector(
  (state: IRootState) => state[name].open,
  (state: IRootState) => state[name].message,
  (open, message) => ({ open, message }),
);

export default slice;
